<bzg-modal-header>
    <div class="bmc-deployment-decrypt__header">
        <span>{{'DEPLOYMENT.SLAVE_TITLE' | translate}}</span>
        <bzg-button-icon class ="icon-close" icon="icon-close" (click)="close()"></bzg-button-icon>
    </div>
  </bzg-modal-header>
  <bzg-modal-content>
    <div>
        <span class="bmc-deployment-decrypt__text bz-space--stack-m">{{'DEPLOYMENT.SlaveRestriction' | translate}}</span>
    </div>
  </bzg-modal-content>
  <bzg-modal-footer class="bmc-delete-alert__footer">
    <bzg-button-secondary (click)="OnNot()" class="bz-space--inline-m">{{ 'DEPLOYMENT.Not' | translate }}
    </bzg-button-secondary>
    <bzg-button-primary (click)="OnYes()">{{'DEPLOYMENT.Yes' | translate}}</bzg-button-primary>
  </bzg-modal-footer>
  